import * as React from 'react';

import KeyInformationSpecializationDurationAndSchedule from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationSpecializationDurationAndSchedule';
import { KeyInformationItemNames } from 'bundles/unified-description-page-common/types/moduleConfig';

const MAX_NUMBER_OF_KIM_ITEMS = 5;

const combineDurationAndSchedule = ({
  items,
  totalLearningMonths,
  learningHoursPerWeek,
}: {
  items: (JSX.Element | null)[];
  totalLearningMonths?: number | null;
  learningHoursPerWeek?: number | null;
}) => {
  if (
    items.length > MAX_NUMBER_OF_KIM_ITEMS &&
    items.find((item) => item?.key === KeyInformationItemNames.Schedule) &&
    items.find((item) => item?.key === KeyInformationItemNames.Duration)
  ) {
    const newItems = items.filter((item) => item?.key !== KeyInformationItemNames.Schedule);
    const durationIndex = newItems.findIndex((item) => item?.key === KeyInformationItemNames.Duration);

    newItems.splice(
      durationIndex,
      1,
      <KeyInformationSpecializationDurationAndSchedule
        totalLearningMonths={totalLearningMonths ?? 0}
        learningHoursPerWeek={learningHoursPerWeek ?? 0}
        key={KeyInformationItemNames.Duration}
      />
    );
    return newItems;
  }

  return items;
};

export default combineDurationAndSchedule;
